import { createContext, useContext, useState, useEffect } from 'react';
import { nGetUserProfile } from "./ReqShare.js";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState(null);
  const [isFetching, setIsFetching] = useState(false);

  const initUser = async () => {

    if (isFetching) { return; }

    setIsFetching(true);

    try {

      const rep = await nGetUserProfile();

      if (rep?.user) { setUserData(rep.user); }
    } catch (err) {
      setUserData(null);
    } finally {
      setIsFetching(false);
    }
  };

  useEffect(() => {
    initUser();
  }, []);

  useEffect(() => {
    const handleStorage = (e) => {
      if (e.key === 'uuid') {
        const auth = localStorage.getItem('auth');
        if (auth && auth != 0) { initUser(); } else { setUserData(null); }
      }
    };

    // 監聽來自 Req.js 的自動刷新成功事件
    const handleAuthUpdate = () => {
      const auth = localStorage.getItem('auth');
      if (auth && auth != 0) { initUser(); }
    };

    window.addEventListener('storage', handleStorage);
    window.addEventListener('auth-update', handleAuthUpdate);
    return () => {
      window.removeEventListener('storage', handleStorage);
      window.removeEventListener('auth-update', handleAuthUpdate);
    };
  }, []);

  return (
    <UserContext.Provider value={{ userData, setUserData, initUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
